import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { BlackButton } from '../../Styles/Button';
import { Link } from 'react-router-dom';
import { alpha, Box, Divider, Grid } from '@mui/material';
import ModalNumber from '../ModalNumber'; 
import { Info } from '@mui/icons-material';
import le_blanc from '../../Assets/le_blanc.webp';
import rose_633 from '../../Assets/rose_633.webp';
import mt_r from '../../Assets/mt_r.webp';
import pinot_noir from '../../Assets/pinot_noir.webp';
import product from '../../Assets/product.png';
import verre from '../../Assets/verre.webp';
import verres from '../../Assets/verres.webp';
import grenache_syrah from '../../Assets/grenache_syrah.webp';

export const BoutiqueCard = ({product}) => {
  let  { title, subtitle, price, totalUnits, bookedUnits, image='product.png' } = product;
  const [isOpen, setIsOpen] = React.useState(false);
  const availableUnits = totalUnits - bookedUnits;

  if (!image) {
    image = 'product.png';
  }

  return (
  <>
    <Card
      onClick={() => {
        availableUnits > 0 ? setIsOpen(true) : setIsOpen(false)
      }}
      sx={{
        textDecoration: "none",
        boxShadow: 1,
        cursor: 'pointer',
        backgroundColor: '#FBFCFA',
        alignContent: 'center',
        alignItems: 'center',
        justifyItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        borderRadius: '28px',
        paddingY: '20px', // Haut et bas
        paddingX: '5px', // Gauche et droite
        position: 'relative',
        flexDirection: 'column',
        marginBottom: '20px',
        maxWidth: {xs: '90%', sm: '70%', md: '55%'},
      }}
    >
      {
      availableUnits <= 0 &&
      <Box
        sx={{
          top: 0,
          right: 0,
          width: '100%',
          height: '100%',
          backgroundColor: alpha('#616161', 0.6), // Transparence avec alpha
          zIndex: 100,
          display: 'flex',
          position: 'absolute',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{
            position: 'relative',
            textAlign: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            fontSize: 50,
            width: '100%',
            fontWeight: 'bold',
            color: '#FBFCFA',
            transform: 'rotate(-45deg)', // Applique une rotation de 45 degrés en sens horaire
            display: 'inline-block', 
          }}
        >
          Sold Out
        </Typography>
      </Box>
      }
      <Box
          className="card-bg"
          sx={{
            height: '128px',
            width: '128px',
            backgroundColor: '#16191e',
            zIndex: 1,
            position: 'absolute',
            top: '-80px',
            right: '-65px',
            borderRadius: '20%',
            transition: 'all .5s ease',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        />
        <Info
          sx={{
            position: 'absolute',
            color: '#FBFCFA',
            zIndex: 2,
            top: '12px',
            right: '17px',
          }}
        />
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          textAlign: 'center',
        }}
      >
        <img src={image?.startsWith("data:image/") ? image : require(`../../Assets/${image}`)} alt="product" style={{ width: '70%', height: 'auto', borderRadius: '20px' }} />
        <Typography
          className='hover-black-typography'
          variant="h5"
          sx={{
            paddingTop: 2,
            display: 'inline-block',
            transition: 'color .2s ease',
            fontWeight: 'bold',
            fontSize: '18px',
            color: '#0B1616',
            zIndex: 2,
            position: 'relative',
          }}
        >
          {title}
        </Typography>
        <Divider orientation="horizontal" sx={{width: '80%', borderBottomWidth:2, paddingTop: 0.5, zIndex: 2}} />
        <Typography
          variant="h6"
          sx={{
            paddingTop: 0.5,
            display: 'inline-block',
            transition: 'color .2s ease',
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#9e9e9e',
            zIndex: 2,
            position: 'relative',
          }}
        >
          {subtitle}
        </Typography>
      </Box>
      <BlackButton>{price} €</BlackButton>
    </Card>
    <ModalNumber isOpen={isOpen} setIsOpen={setIsOpen} product={product} />
  </>
  );
}

export default BoutiqueCard;